import React from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { Button, CircularProgress } from '@material-ui/core';
import Paper from '@material-ui/core/Paper'
import axios from 'axios'
import OptionsList from './ProposalSettings/SizeOptionsList'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const Sizes = (props) => {
  // console.log('Generic Options Component', props)
  const [list, setList] = React.useState([])
  const [state, setState] = React.useState({
    counter: 0
  })
  const optionType = `size`
  let dataToUse = {
    name: 'Size',
    title: 'Size Options',
    formalName: 'Sizes'
  }
  React.useEffect(() => {
    let isMounted = true
    async function fetchOptions () {
      axios
      .get(
        `${props.url}/api/settings/getGenericOptions?type=${optionType}`
        )
      .then(({ data }) => {
        // console.log("Data", data)
        if (isMounted) setList(data)
      }).catch(function (err) {
      // console.log('Error getting stuff', err)
      });
    }
    fetchOptions()
    return () => {
      isMounted = false
    }
  }, [])

  const updateOptions = (optionToUpdate) => {
    // console.log('Update Size: ', optionToUpdate)
    let existingOptions = list
    // console.log('Update Objective: ', scope)
    // console.log('Got %d clients: ', clients.length)
    let index = existingOptions.findIndex(item =>  (item._id === optionToUpdate._id))
    if (index > -1) {
      // console.log('Svc already exists', index)
      // console.log(services[index])
      existingOptions[index] = optionToUpdate
      // console.log('Agai: ', services[index])
      // console.log(services)
      // setRows(services)
      // setFilteredRows(services)
      setList(existingOptions)
    } else {
      existingOptions.push(optionToUpdate)
      setList(existingOptions)
    }
    setState({...state, counter: state.counter++ })
  }

  const deleteFromDB = async (id) => {
    axios({
      method: 'post',
      url:  `${props.url}/api/settings/deleteOption?id=${id}`,
      data: {
        type: optionType,
        id: id
      }
    }).then(response => {
      // console.log('Axios response from deleting objective: ', response)
      if (response && response.data && response.data.deleted) {
        props.notification({
          title: 'Option Deleted',
          message: 'That Option Is History!',
          type: 'success'
        })
      }
    })
  }

  const handleDelete = (id) => {
    // console.log('Delete ', id)
    let existingOptions = list
    let index = existingOptions.findIndex(item =>  (item._id ===  id))
    // console.log('index', index)
    if (index > -1) {
      existingOptions.splice(index, 1)
      setList(existingOptions)
      deleteFromDB(id)
    }
  }

  const handleBack= () => {
    props.history.push('/settings')
  }
  // console.log(dataToUse)
  return (
    <div style={{padding: '5px', margin: '10px'}}>
      <Grid container>
        <Grid item lg={6} xs={12}>
          <h1>Size Options</h1>
        </Grid>
        <Grid item lg={6} xs={12}>
        </Grid>
        <Grid item lg={12} xs={12}>
          <Paper style={{ minHeight: '80vh' }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              style={{margin: 8}}
              startIcon={<ArrowBackIcon />}>Back</Button>
            <Grid container spacing={4} style={{ padding: '10px' }}>
            
              <Grid item lg={12} xs={12}>
                <OptionsList list={list} type={optionType} dataToUse={dataToUse} updateOption={updateOptions} deleteOption={handleDelete} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      
  </div>
  )
}

  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification
    }
  }
  
  export default connect(mapStateToProps)(Sizes)